import { render, staticRenderFns } from "./FormProcedimento.vue?vue&type=template&id=b88ee7aa"
import script from "./FormProcedimento.vue?vue&type=script&lang=js"
export * from "./FormProcedimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports